/**
 * Ключи полей, которые reloadElement может перезаписать в pagesData.
 */
export function buildReloadElementMergeScopeKeys(
  reloadedFieldName: string,
  extraFieldNames: string[] = [],
  incomingFields: Record<string, unknown> | null | undefined = {},
): Set<string> {
  const scope = new Set<string>()
  const add = (key: string) => {
    const k = String(key ?? '').trim()
    if (k) scope.add(k)
  }

  const reloaded = String(reloadedFieldName ?? '').trim()
  if (reloaded) {
    add(reloaded)
  }

  // Весь payload ответа reload — в scope (sibling tables + aux).
  for (const key of Object.keys(incomingFields ?? {})) {
    add(key)
  }

  for (const name of extraFieldNames) {
    add(name)
  }

  return scope
}
